import { fmt, rd } from "./fniShared";

const rate = (v) => (v >= 50 ? "text-emerald-700" : v >= 30 ? "text-amber-600" : "text-red-600");
const HEADS = ["Banco", "Sometidas", "Aprob.", "Firm.", "Desest.", "Rech.", "En espera", "% Aprob.", "RD$ sometido", "RD$ aprobado"];

export default function FniBanksTable({ banks, onPick }) {
  return (
    <section className="surface p-4 mb-5 min-w-0" data-testid="fni-banks">
      <h3 className="font-display font-extrabold text-base">Por banco</h3>
      <p className="text-[11px] text-gray-500 font-semibold mb-3">Haz clic en un banco para filtrar todo el dashboard · RD$ estimado con la cotización más reciente del cliente</p>
      <div className="overflow-x-auto">
        <table className="w-full text-[13px]">
          <thead>
            <tr className="text-[10px] uppercase tracking-wider text-gray-400 border-b">
              {HEADS.map((h, i) => <th key={h} className={`py-2 px-1.5 font-extrabold ${i ? "text-right" : "text-left"}`}>{h}</th>)}
            </tr>
          </thead>
          <tbody>
            {banks.length === 0 && (
              <tr><td colSpan={HEADS.length} className="py-4 text-center text-gray-400 font-semibold" data-testid="fni-banks-empty">Sin oportunidades sometidas en este filtro</td></tr>
            )}
            {banks.map((b, i) => (
              <tr key={b.name} className="border-b border-gray-50 hover:bg-cyan-50/40 cursor-pointer"
                  onClick={() => onPick(b.name)} data-testid={`fni-bank-row-${i}`}>
                <td className="py-1.5 px-1.5 font-bold text-gray-800">{b.name}</td>
                <td className="py-1.5 px-1.5 text-right tabular-nums font-bold">{fmt(b.sometido)}</td>
                <td className="py-1.5 px-1.5 text-right tabular-nums text-emerald-700">{fmt(b.aprobado)}</td>
                <td className="py-1.5 px-1.5 text-right tabular-nums text-emerald-800">{fmt(b.firmado)}</td>
                <td className="py-1.5 px-1.5 text-right tabular-nums text-gray-500">{fmt(b.desestimado)}</td>
                <td className="py-1.5 px-1.5 text-right tabular-nums text-red-600">{fmt(b.rechazado)}</td>
                <td className="py-1.5 px-1.5 text-right tabular-nums text-amber-600">{fmt(b.en_espera)}</td>
                <td className={`py-1.5 px-1.5 text-right tabular-nums font-extrabold ${rate(b.approval_rate)}`}>{b.approval_rate}%</td>
                <td className="py-1.5 px-1.5 text-right tabular-nums whitespace-nowrap">{rd(b.monto_sometido)}</td>
                <td className="py-1.5 px-1.5 text-right tabular-nums whitespace-nowrap text-emerald-700">{rd(b.monto_aprobado)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
